<template>

  <component :is="layout">
    <nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">
      <div class="container-fluid">
        <a class="h4 mb-0 text-white text-uppercase d-none d-lg-inline-block" href="#">
          <i class="far fa-money-bill-alt"></i> {{ $i18n.t('global.banknotes') }}
        </a>

        <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
          <div class="form-group mb-0">
            <div class="input-group input-group-alternative">
              <div class="input-group-prepend">
                <span class="input-group-text"><i class="fas fa-search"></i></span>
              </div>
              <input type="text" v-model="search" class="form-control" :placeholder="$i18n.t('global.search')">
            </div>
          </div>
        </form>

        <ul class="navbar-nav align-items-center d-none d-md-flex">
          <li class="nav-item dropdown">
            <a class="nav-link pr-0" href="#" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
              <div class="media align-items-center">
                <span v-if="user" class="photoURL avatar avatar-sm rounded-circle" :style="{ 'background-image': 'url('+user.photoURL+')' }">
                </span>
                <div class="media-body ml-2 d-none d-lg-block">
                  <span class="mb-0 text-sm  font-weight-bold">{{ user ? user.displayName : '' }}</span>
                </div>
              </div>
            </a>
            <div class="dropdown-menu dropdown-menu-arrow dropdown-menu-right">
              <Menu key="Banknotes" />
            </div>
          </li>
        </ul>

      </div>
    </nav>

    <div class="header bg-gradient-primary pb-6 pt-5 pt-md-6"></div>

    <div class="container-fluid mt--7">

      <div class="row mt-5">
          <div class="col">
            <div class="card shadow">
              <div class="card-header border-0">
                <h3 class="mb-0" style="float:left">
                  <button style="margin:0 !important" type="button" class="btn btn-primary btn-sm" @click="$router.replace({ name: 'banknote.new' })"><i class="fas fa-plus"></i></button>
                  <span v-if="title">{{ $i18n.t('continents.'+title.code) }}</span>
                  <small v-if="banknotes">{{ nbBanknotes > 1 ? nbBanknotes + ' ' + $i18n.t('global.banknotes').toLowerCase() : nbBanknotes + ' ' + $i18n.t('global.banknote').toLowerCase() }}</small>
                </h3>
                <div style="float:right; display:flex">
                  <div class="dropdown" v-if="countries">
                    <button class="btn btn-sm btn-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{ $i18n.t('coins.select_country') }}</button>
                    <div class="dropdown-menu full-width" style="height: 350px; overflow-y: scroll;" aria-labelledby="dropdownMenuButton">
                      <a class="dropdown-item full-width" v-for="(country, index) in countries" :key="'country'+index" @click="goToBanknotesCountry(country.code.toLowerCase())">{{ $i18n.t('countries.'+country.code) }}</a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="banknotes" id="listBanknotes">
                <div v-if="banknotes.length > 0" class="table-responsive">
                  <table class="table align-items-center table-flush">
                    <thead class="thead-light">
                      <tr>
                        <th scope="col" width="20%">{{ $i18n.t('global.image') }}</th>
                        <th scope="col" class="sort-hover" width="60%" @click="sort('title')">
                          {{ $i18n.t('global.banknote') }}
                          <i class="fas fa-sort"></i>
                        </th>
                        <th scope="col" class="sort-hover" width="10%" @click="sort('quantity')">
                          {{ $i18n.t('global.quantity') }}
                          <i class="fas fa-sort"></i>
                        </th>
                        <th scope="col" width="10%"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(banknote, index) in filteredBanknotes" :key="banknote.key">
                        <td scope="row" width="20%">
                          <div style="width:100px;margin:0 auto;">
                            <a @click="$router.replace({ name: 'banknote.show', params: { key: banknote.key } })">
                              <img :src="banknote.image" :alt="banknote.title" class="img-responsive img-banknote">
                            </a>
                          </div>
                        </td>
                        <td scope="row" width="60%">
                          <span class="font-weight-800">{{ banknote.title }}</span><br>
                          <small><i>{{ banknote.book.name }}</i></small><br>
                          <span v-if="banknote.country">
                            <img :src="'https://www.countryflags.io/'+banknote.country.toLowerCase()+'/flat/24.png'" :alt="banknote.country"> {{ $i18n.t('countries.' + banknote.country) }},
                          </span>
                          {{ $i18n.t('continents.' + banknote.continent) }}
                        </td>
                        <td scope="row" width="10%">{{ banknote.quantity }}</td>
                        <td scope="row" width="10%">
                          <button style="margin:5px 0 0 0 !important" type="button" class="btn btn-primary" @click="$router.replace({ name: 'banknote.show', params: { key: banknote.key } })">
                            <i class="far fa-eye"></i>
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div v-if="banknotes.length > 0" class="card-footer py-4">
                  <nav>
                    <ul class="pagination justify-content-end mb-0">
                      <li class="page-item" :class="{ 'disabled': currentPage == 1 }">
                        <div class="page-link" @click="prevPage">
                          <i class="fas fa-angle-left"></i>
                          <span class="sr-only">Previous</span>
                        </div>
                      </li>
                      <li class="page-item" :class="{ 'disabled': (currentPage * pageSize) >= banknotes.length }">
                        <div class="page-link" @click="nextPage">
                          <i class="fas fa-angle-right"></i>
                          <span class="sr-only">Next</span>
                        </div>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
              <div v-else class="text-center mt-5 mb-5">
                <img src="../../../static/img/loading.gif" alt="Loading" width="75">
              </div>
            </div>
          </div>
        </div>

      <Footer />

    </div>
  </component>

</template>

<script>
import Footer from '../../layouts/Footer'
import Modal from '../../layouts/Modal'
import Menu from '../../layouts/Menu'
import { Carousel, Slide } from 'vue-carousel'

export default {
  name: 'BanknotesContinent',
  components: { Footer, Modal, Carousel, Slide, Menu },
  data () {
    return {
      nbBanknotes: 0,
      search: '',
      currentSort: 'banknote',
      currentSortDir: 'asc',
      pageSize: 10,
      currentPage: 1
    }
  },
  computed: {
    layout () {
      return 'Layout'
    },
    title () {
      return this.$store.getters.continent
    },
    filteredBanknotes () {
      this.nbBanknotes = 0
      if (this.banknotes) {
        let filtered = this.banknotes.filter(banknote => {
          return banknote.title.toLowerCase().indexOf(this.search.toLowerCase()) > -1
        })
        this.nbBanknotes = filtered.length > 0 ? filtered.map(banknote => banknote.quantity).reduce((a, b) => a + b) : 0
        return filtered.sort((a, b) => {
          let modifier = 1
          if (this.currentSortDir === 'desc') modifier = -1
          if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
          if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
          return 0
        }).filter((row, index) => {
          let start = (this.currentPage - 1) * this.pageSize
          let end = this.currentPage * this.pageSize
          if (index >= start && index < end) return true
        }).sort((a, b) => new Date(b.created_at) - new Date(a.created_at))
      }
      return null
    },
    banknotes () {
      return this.$store.getters.banknotes
    },
    countries () {
      return this.$store.getters.countries
    },
    user () {
      return this.$store.getters.user
    }
  },
  created () {
    this.$store.dispatch('fetchUser')
    this.$store.dispatch('fetchContinent', { code: this.$route.params.code.toUpperCase() })
    this.$store.dispatch('fetchCountries', { codeContinent: this.$route.params.code.toUpperCase() })
    this.$store.dispatch('fetchBanknotes', { continentCode: this.$route.params.code.toUpperCase() })
  },
  methods: {
    goToBanknotesCountry (codeCountry) {
      this.$router.replace({ name: 'banknote.country', params: { code: codeCountry } })
    },
    sort (s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    nextPage () {
      if ((this.currentPage * this.pageSize) < this.banknotes.length) this.currentPage++
    },
    prevPage () {
      if (this.currentPage > 1) this.currentPage--
    }
  }
}
</script>

<style scoped>
  .margin-images {
    display: flex;
    margin-top: 5px;
    margin-bottom: 5px;
  }
  #search { height: 30px; }
  .sort-hover:hover { cursor: pointer; }
</style>



// WEBPACK FOOTER //
// src/components/Banknote/BanknotesContinent.vue